export default __webpack_public_path__ + "d6299e591156c30879d3fe74eecde724.mp3";